<template>
  <router-view v-if="readyToRender"></router-view>
  <div class="fs-11 mt-5 mb-3 text-center">&#169; SIGNUM | App Version v3.0</div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  computed: {
    readyToRender () {
      // When logged in, block rendering anything until the user profile is loaded so all components can be sure it is available to them
      if (this.$store.getters.isUserLoggedIn && !this.$store.getters.getUserProfile?.id) return false
      return true
    }
  },
  async created () {
    // Read the persisted session_token. Prefer the new `sessionToken` key
    // (raw string). Fall back to the legacy `userProfile` key (an object
    // that used to hold the full profile, then later just `{ session_token }`)
    // so users who logged in before the rename stay logged in. Clean up
    // the legacy key on first read so it doesn't linger.
    //
    // Two layers of fallback in the legacy blob:
    //   1. `session_token` — set by frontends after the session_token migration
    //   2. `access_token` — set by the original frontend (long-lived `snp_…`
    //      token). The API accepts both formats on the Bearer header (see
    //      AccessTokenHandler), so using it as a session_token keeps users
    //      logged in across the rename. It gets replaced by a real `sns_…`
    //      token on their next /authenticate (manual login). 
    let sessionToken = localStorage.getItem("sessionToken")
    if (!sessionToken) {
      const legacy = localStorage.getItem("userProfile")
      if (legacy) {
        try {
          const parsed = JSON.parse(legacy)
          sessionToken = parsed?.session_token || parsed?.access_token || null
        } catch (e) {
          sessionToken = null
        }
        // Cleaning up sensitive data from the old way of storing this info
        localStorage.removeItem("userProfile")
        localStorage.removeItem("userToken")
      }
    }
    if (sessionToken) {
      this.$store.commit('setUserProfile', { userProfile: { session_token: sessionToken } })
    }

    // This is needed to fetch the newest profile infos from the API otherwise users need to reload the page before they see their subscription show up
    await this.$store.dispatch('getUserProfile')

    // Store new UTMs in local storage and load the existing ones into the store if they exist
    await this.$router.isReady()
    let newUTMs = {
      medium: this.$route.query.utm_medium,
      source: this.$route.query.utm_source,
      campaign: this.$route.query.utm_campaign,
      term: this.$route.query.utm_term,
      content: this.$route.query.utm_content
    }
    this.$store.commit('setUTMs', { utms: newUTMs })

    // Set theme on init
    this.$store.commit('setTheme', {})
    document.getElementsByTagName('html')[0].dataset.bsTheme = await this.$store.getters.getTheme

    // Set privacy on init
    this.$store.commit('setProtectPrivacy', {})

    // Load the last /updates visit time so the navbar unread badge is correct on init
    this.$store.commit('setUpdatesLastReadAt', {})

    // Only activate Posthog in the prod env
    if (process.env.VUE_APP_ENV != 'prod') this.$posthog.opt_out_capturing()
  }
}
</script>

<style>
div.card {
  /* overflow: hidden; */ /* Fixes the line that appears on the bottom of the card when it ends with a table row. But BREAKS the popup menu because it get's cut off with this. */
}
/* Makes it easier to make bold font compared to using .fw-bold all the time */
b {
  font-weight: 700 !important;
}
</style>
